import React, { FunctionComponent } from 'react';
import { useFormContext } from 'react-hook-form';
import { DonateButtonFormData } from '../../../../types/givingCheckoutForm';
import config from '../../../config';
import usePaymentLogos from '../usePaymentLogos';

const JustGivingButtonPreview: FunctionComponent = () => {
  const { largeButtonFilename, paymentTypeLogosFilename, paymentTypesList } =
    usePaymentLogos();

  const { watch } = useFormContext<DonateButtonFormData>();
  const includePaymentLogos = watch('includePaymentLogos');
  const buttonSize = watch('buttonSize');

  const largeButtonStyles: React.CSSProperties = {
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    width: 256,
    margin: '12px auto',
  };

  if (buttonSize === 'large') {
    return (
      <div aria-hidden className="justgivingDonateButton__preview">
        <span style={largeButtonStyles}>
          <img
            data-qa="button-large"
            src={`${config.jg_cdn_url}buttons/${
              includePaymentLogos
                ? largeButtonFilename
                : 'donate-with-jg-large.svg'
            }`}
            alt={`Donate with JustGiving. ${paymentTypesList}`}
          />
        </span>
      </div>
    );
  }

  const smallButtonWrapperStyles: React.CSSProperties = {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 296,
    minWidth: 256,
    margin: '12px auto',
  };
  const smallButtonStyles: React.CSSProperties = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '48px',
    backgroundColor: '#7a04dd',
    borderRadius: '3px',
    marginBottom: '12px',
  };

  return (
    <div aria-hidden className="justgivingDonateButton__preview">
      <span style={smallButtonWrapperStyles}>
        <span style={smallButtonStyles}>
          <img
            src={`${config.jg_cdn_url}buttons/donate-with-jg.svg`}
            alt="Donate with JustGiving."
          />
        </span>
        {includePaymentLogos && (
          <img
            src={`${config.jg_cdn_url}buttons/${paymentTypeLogosFilename}`}
            alt={paymentTypesList}
          />
        )}
      </span>
    </div>
  );
};

export default JustGivingButtonPreview;
